import styled from "styled-components"
export const Hero = styled.div`
  position: relative;
  height: 90vh;
  background-repeat: no-repeat;
  background-size: cover;
  /* overlay transparente -> negro para que se lea el título blanco */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 0.55) 100%
    );
    pointer-events: none;
  }
  &.bgleft
  {
  background-position: left;
  }
  &.bgcenter
  {
    background-position: center;
  }
  &.bgcenter.bgbottom
  {
    background-position: center bottom;
  }
  /* /buses: la foto es vertical; "abajo" deja solo la pista, 57% muestra el bus completo */
  &.bgcenter.bgbuses
  {
    background-position: center 57%;
  }
  /* /bus/urbano en tablet y móvil: bus debajo del título, que queda sobre el cielo */
  @media (max-width: 1024px) {
    &.bgcenter.bgurbano
    {
      background-size: auto 115%;
      background-position: 32% 0%;
    }
  }
  &.heroBlog{
    height: 50vh;
  }
  .banner {
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    color: ${({ theme }) => theme.colors.gris};
    font-size: ${({ theme }) => theme.fontsize.large};
    padding: 0 2rem;
    display: grid;
    justify-content: end;
    justify-items: center;
    &__title {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
      max-width:40rem;
    }
    &__space {
      background-color: ${({ theme }) => theme.colors.gris};
      width: 3px;
      height: 100%;
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    }
    .logoIsoTipoSvg {
      fill: ${({ theme }) => theme.colors.amarillo};
      grid-column: 2 / 3;
      grid-row: 1 / 2;
      margin-bottom: 1rem;
    }
  }
  
  @media (max-width: 800px) {
    /* en móvil el título va al centro: oscurecer toda la imagen */
    &::before {
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.15),
        rgba(0, 0, 0, 0.5)
      );
    }
    .banner {
      grid-template-columns: 1fr;
      position:relative;
      align-items:center;
      height:100%;
      &__title {
        text-align: center;
        grid-column:auto;
        grid-row:auto;
        text-transform: uppercase;
        :hover{
          ::before{
          transform:translateX(100%);
          transition:.3s;
          }
          ::after{
          transform:translateX(-100%);
          transition:.3s;
          }
        }
        ::before,::after{
          content:'';
          display:block;
          width:50%;
          height:3px;
          transition:1s;
          background-color:${({theme})=>theme.colors.gris};
        }
        ::before{
          margin-bottom:.5rem;
        }
        ::after{
          margin-top:.5rem;
          margin-left:auto;
        }
      }
      &__space,
      .logoIsoTipoSvg {
        display: none;
      }
    }
  }
`
